<div class="bg-white text-center mt-3">
  <h4>{{ 'service-card.lockCardConfirm' | translate }}</h4>
</div>
<div *nzModalFooter>
  <button nz-button class="btn-cancel-modal" (click)="destroyModal()">{{ 'cancel' | translate }}</button>
  <button nz-button nzType="primary" (click)="confirm()">{{ 'confirm' | translate }}</button>
</div>
